import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
const footerCss = "f8enngm";
export const CloseConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm
}) => <Popup isOpen={isOpen} onClose={onClose} size="small" title={I18n.t('publisher.meeting_recap.share_modal.close_confirmation.title')}>
    <Body>
      {I18n.t('publisher.meeting_recap.share_modal.close_confirmation.body')}
    </Body>
    <Footer className={footerCss}>
      <Button decoration="secondary-outline" onClick={onClose} wide>
        {I18n.t('publisher.meeting_recap.share_modal.close_confirmation.back')}
      </Button>
      <Button onClick={onConfirm} wide>
        {I18n.t('publisher.meeting_recap.share_modal.close_confirmation.confirm')}
      </Button>
    </Footer>
  </Popup>;

require("./close_confirmation_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./close_confirmation_modal.js");